// Web.API returns an associative array, but neither of these HTMLs are working.
// So, convert to object with id and value for use with ng-options="item.id as item.value for item in qualifiedUsers"
//
//<option ng-repeat="(id, name) in qualifiedUsers" value="{{id}}">{{name}}</option>
//ng-options="key as value for (key, value) in qualifiedUsers"
//scope.qualifiedUsers = response.data;
//
//angular.forEach(response.data, function(item, key){ scope.qualifiedUsers.push({id: key, value: item})})

(function () {
    'use strict';

    angular
        .module('app')
        .directive('selectioncommandcreateversion', selectioncommand_createversion);

    selectioncommand_createversion.$inject = ['$window', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService'];

    function selectioncommand_createversion($window, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService) {
        // Usage:
        //     <toolbar></toolbar>
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                //    selectedItems: '=',
                createVersionDialogShown: '=?'
            },
            templateUrl: 'app/selectioncommand/selectioncommand_createversion.html'
        };
        return directive;

        function link(scope, element, attrs) {

           
        }

    }

})();